<div class="account-settings-project-container">
    <!-- Header Section -->
    <div class="header-section">
        <div class="header-actions">
            <button 
                type="button" 
                class="btn btn-primary create-project-btn" 
                [disabled]="!isUserHasWriteAccess"
                (click)="openNewProjectPanel()">
                <!-- <i class="fa fa-plus-circle"></i> -->
                New Project
            </button>
        </div>
        <div class="search-section">
            <div class="search-input-wrapper">
                <i class="fa fa-search search-icon"></i>
                <input 
                    type="text" 
                    class="search-input" 
                    (input)="searchProject()" 
                    [(ngModel)]="searchValue" 
                    placeholder="Search projects..." 
                    autofocus>
            </div>
        </div>
    </div>

    <!-- Custom Table Section -->
    <div class="custom-table-section" *ngIf="projects.length > 0">
        <table class="projects-table">
            <thead>
                <tr>
                    <th class="col-projects">Projects</th>
                    <th class="col-created-by">Created By</th>
                    <th class="col-created-date">Created Date</th>
                    <th class="col-status">Status</th>
                    <th class="col-visibility">
                        <span class="visibility-header">
                            Dashboard Visibility
                            <i class="fa fa-info-circle visibility-help-icon"
                               ngbTooltip="This checkbox is enabled only for admins to control dashboard visibility of closed projects."
                               container="body"
                               placement="bottom"
                               aria-label="Dashboard visibility help"></i>
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let project of projects" class="project-row">
                    <td class="col-projects">{{ project.name || 'NA' }}</td>
                    <td class="col-created-by" [title]="getCreatorName(project)">{{ getCreatorName(project) }}</td>
                    <td class="col-created-date">{{ getCreatedDate(project) }}</td>
                    <td class="col-status">{{ project.project_status_name || 'NA' }}</td>
                    <td class="col-visibility">
                        <div class="visibility-checkbox-wrapper" 
                             [class.disabled]="!isProjectClosed(project) || !isUserHasWriteAccess">
                            <label class="lw3-checkbox-container">
                                <input 
                                    type="checkbox" 
                                    [checked]="getIsDisplayOnDashboard(project)" 
                                    [disabled]="!isProjectClosed(project) || !isUserHasWriteAccess"
                                    (change)="updateBrandDetails(project)">
                                <span class="lw3-checkmark"></span>
                            </label>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- No Data Message -->
    <div class="no-data-section" *ngIf="projects.length === 0 && !isNoMoreClosedProject">
        <p>Loading projects...</p>
    </div>

    <div class="no-data-section" *ngIf="isNoMoreClosedProject">
        <p>No projects found.</p>
    </div>
</div>

<!-- Project Form Panel -->
<app-project-form-panel 
    [existingProjectCount]="projectsList.length"
    [isSelfServiceUser]="isSelfServiceUser"
    (closePanel)="onProjectCreated()"
    (projectCreated)="onProjectCreated($event)">
</app-project-form-panel>
